import { Controller } from "@hotwired/stimulus"

// One form, several screens: shows one step at a time with Back / Next in the
// footer and Save on the last. Nothing is posted until Save (D-1); the server
// picks the initial step so a rejected save reopens where the problem is.
// DaisyUI's .btn and .form-control set their own display, which beats the
// [hidden] attribute; `!hidden` wins. Both are set so either reads as hidden.
export function setHidden(element: HTMLElement, hidden: boolean) {
  element.hidden = hidden
  element.classList.toggle("!hidden", hidden)
}

export default class extends Controller {
  static targets = ["step", "back", "next", "submit"]
  static values = { index: { type: Number, default: 0 } }

  declare readonly stepTargets: HTMLElement[]
  declare readonly backTarget: HTMLElement
  declare readonly nextTarget: HTMLElement
  declare readonly submitTarget: HTMLElement
  declare indexValue: number

  connect() {
    this.show(this.indexValue)
  }

  next() {
    this.show(Math.min(this.indexValue + 1, this.stepTargets.length - 1))
  }

  back() {
    this.show(Math.max(this.indexValue - 1, 0))
  }

  private show(index: number) {
    this.indexValue = index
    this.stepTargets.forEach((step, i) => setHidden(step, i !== index))
    const last = index === this.stepTargets.length - 1
    setHidden(this.backTarget, index === 0)
    setHidden(this.nextTarget, last)
    setHidden(this.submitTarget, !last)
    this.element.closest(".modal-body-container")?.scrollTo({ top: 0 })
  }
}
